import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'normalize.css/normalize.css'
import 'animate.css'

import ElementTiptapPlugin from 'element-tiptap'
import 'element-tiptap/lib/style.css'

import ElementPlus, { ElOption } from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

import Vue3ColorPicker from 'vue3-colorpicker'
import 'vue3-colorpicker/style.css'

import VueCropper from 'vue-cropper'
import 'vue-cropper/dist/index.css'

import VueClipboard from 'vue3-clipboard'

import VueLazyload from 'vue-lazyload'

const loadimage = require('@/assets/img/loading-spin.svg')

ElOption.props.value.type = undefined

createApp(App)
  .use(ElementPlus)
  .use(store)
  .use(router)
  .use(Vue3ColorPicker)
  .use(VueCropper)
  .use(VueClipboard, {
    autoSetContainer: true,
    appendToBody: true,
  })
  .use(VueLazyload, {
    preLoad: 1.3,
    loading: loadimage,
    attempt: 1,
  })
  .use(ElementTiptapPlugin)
  .mount('#app')
